<div class="fixed bottom-6 right-6 z-[9999] flex flex-col gap-3 pointer-events-none">
    @for (t of toast.toasts(); track t.id) {
        <div
            class="flex items-start gap-3 px-4 py-3 rounded-2xl border shadow-lg pointer-events-auto max-w-sm text-sm font-semibold transition-all"
            [ngClass]="{
                'bg-slate-900 border-slate-700 text-white': t.type === 'info',
                'bg-green-900/80 border-green-600/50 text-green-200': t.type === 'success',
                'bg-yellow-900/80 border-yellow-600/50 text-yellow-200': t.type === 'warning'
            }">
            <!-- Icon -->
            @if (t.type === 'success') {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0">
                    <polyline points="20 6 9 17 4 12"/>
                </svg>
            } @else if (t.type === 'warning') {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                    <line x1="12" y1="9" x2="12" y2="13"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
            } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 flex-shrink-0">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="12"/>
                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
            }
            <span class="flex-1">{{ t.message }}</span>
            <button (click)="toast.dismiss(t.id)" class="ml-2 opacity-60 hover:opacity-100 transition-opacity flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
            </button>
        </div>
    }
</div>
